import CurriculumHero from './CurriculumHeader';

export default CurriculumHero;
